const mod =
  typeof window !== `undefined`
    ? require('./use-media.browser')
    : require('./use-media.server');

export const useMedia = mod.useMedia as (mediaQuery: string) => boolean;

